import React from 'react';

import { Typography } from '@mui/material';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

import { STATUS_COLUMN_WIDTH } from './Alerts.constants';
import { rowStyles } from './Alerts.styles';
import ChecklistCategoryAccordion from './ChecklistCategoryAccordion';
import ChecklistItem from './ChecklistItem';

export const config = {
  name: {
    label: 'Name',
    width: '46%',
    sort: true,
    content: ({ name }) =>
      name?.content ?? (
        <Typography data-truncated variant="regular14">
          Name
        </Typography>
      ),
    colSpan: ({ name }) => name?.colSpan,
    customStyles: ({ name }) => name?.customStyles,
    sortBy: 'rowName',
  },
  status: {
    label: 'Result',
    width: STATUS_COLUMN_WIDTH,
    tooltip:
      'Outcome of the compliance test, including Needs Review and Not Applicable — or the calculated value for computation rows.',
    content: () => (
      <Typography data-truncated variant="regular14">
        Result
      </Typography>
    ),
    align: HORIZONTAL_ALIGNMENT.CENTER,
  },
  actionDate: {
    label: 'Override',
    width: '14%',
    tooltip:
      'Who manually overrode the automatic result, and when. Blank until an override is applied.',
    content: () => (
      <Typography data-truncated variant="regular14">
        Override
      </Typography>
    ),
  },
  action: {
    label: 'Actions',
    width: '22%',
    tooltip: 'Override the result, create a task, or go to the related field.',
    content: () => (
      <Typography data-truncated variant="regular14">
        Actions
      </Typography>
    ),
  },
};

export const getCategoryRow = ({ category, statusDisplayType, isChecklistRecalculating }) => ({
  name: {
    position: 1,
    colSpan: 4,
    customStyles: rowStyles,
    content: (
      <ChecklistCategoryAccordion
        category={category}
        isChecklistRecalculating={isChecklistRecalculating}
        statusDisplayType={statusDisplayType}
      />
    ),
  },
});

export const getItemRow = ({
  isLast,
  item,
  disabled,
  statusDisplayType,
  isChecklistRecalculating,
}) => ({
  name: {
    position: 1,
    colSpan: 4,
    customStyles: rowStyles,
    content: (
      <ChecklistItem
        disabled={disabled || isChecklistRecalculating}
        isLast={isLast}
        item={item}
        statusDisplayType={statusDisplayType}
      />
    ),
  },
});

export const defaultSortOrder = {
  direction: 'asc',
  id: 'orderSequence',
};
